/*
 * JavaScript controls for sliders, takeovers, and other annoying
 * marketing things (lol?).
 */
var sliders = {
  // If you change the ID here, change it on the HTML as well

  "COUNTDOWN-ONLY": {
    activeOn: "2026-02-11T00:00:00-05:00",
    inactiveOn: "2026-07-11T11:00:00-05:00",
    makeActiveOnStage: true,
    type: "countdown",
    countdown: true,
    includes: {
      // 'sections': [],
      pages: ["/things-to-do/dining/hershey-social/"],
    },
  },

  "hershey-inn-and-suites": {
    activeOn: "2026-04-01T08:00:00",
    inactiveOn: "2026-04-20T23:59:59",
    makeActiveOnStage: true,
    daysDismissLasts: 1,
    hoursDismissLasts: 0,
    type: "takeover",
    countdown: true,
    includes: {
      sections: [],
      pages: ["/", "/index.php"]
    },
    excludes: {
      sections: [],
      pages: []
    }
  },
/*   "hershey-inn-and-suites": {
    activeOn: "April 01, 2026 08:00:00",
    inactiveOn: "April 01, 2026 23:59:59",
    makeActiveOnStage: true,
    daysDismissLasts: 1,
    hoursDismissLasts: 0,
    type: "takeover",
    countdown: true,
    includes: {
      sections: [],
      pages: ["/", "/index.php"]
    },
    excludes: {
      sections: [],
      pages: []
    }
  }, */

};

$(function () {
  $.each(sliders, function (id, slider) {

    Slider.CheckActive(id, slider);

  });
});

var Slider = {
  sliderActivated: false,
  activeSliders: [],

  CheckActive: function (id, sliderInfo) {
    // Is it active?
    // Does it have section or page excludes?
    var relativePath = window.location.pathname;

    if (sliderInfo.excludes) {
      if (sliderInfo.excludes.sections.length) {
        var exclude = false;
        sliderInfo.excludes.sections.forEach(function (section) {
          if (relativePath.indexOf(section) === 1) {
            // exclude hit
            exclude = true;
          }
        });
        if (exclude) {
          return false;
        }
      }
      if (sliderInfo.excludes.pages.length) {
        var exclude = false;
        sliderInfo.excludes.pages.forEach(function (page) {
          if (relativePath == page) {
            // exclude hit
            exclude = true;
          }
        });
        if (exclude) {
          return false;
        }
      }
    }

    if (sliderInfo.includes) {
      /*Include pages*/
      if (sliderInfo.includes.pages.length) {

        var exclude = true;
        sliderInfo.includes.pages.forEach(function (page) {

          if (relativePath == page) {
            // include hit
            exclude = false;
          }
        });
        if (exclude) {
          return true;
        }
      }
    }

    var now = moment();
    var activeTime = moment(new Date(sliderInfo.activeOn));
    var inactiveTime = moment(new Date(sliderInfo.inactiveOn));
    // Only activate if current time is between activeOn and inactiveOn
    if (
      (activeTime.diff(now, "minutes") <= 0 &&
        inactiveTime.diff(now, "minutes") >= 0) 
    ) {
      // Time/server based active state is on. Check user's client.
      if (hasLocalStorage()) {
        var client = localStorage.getItem(id);
        if (!client || client != "no") {
          // Show it
          Slider.Init(id, sliderInfo);
        } else if (client == "no") {
          // Check time stamp. Has the rejection period expired?
          var dismissTime = moment(
            localStorage.getItem(id + "-time"),
            "MM/DD/YYYY HH:mm:ss"
          );
          var hoursSinceDismiss = now.diff(dismissTime, "hours");

          var hoursDismissLasts = parseInt(sliderInfo.hoursDismissLasts);
          if (
            typeof sliderInfo.daysDismissLasts !== "undefined" &&
            sliderInfo.daysDismissLasts > 0
          ) {
            hoursDismissLasts += parseInt(sliderInfo.daysDismissLasts) * 24;
          }
          //console.log(hoursDismissLasts);
          //console.log(hoursSinceDismiss);
          if (hoursSinceDismiss > hoursDismissLasts) {
            // Show it
            Slider.Init(id, sliderInfo);
          }
        }
      } else {
        // For now, just show it if no local storage
        Slider.Init(id, sliderInfo);
      }
    }
  },

  Init: function (id, sliderInfo) {
    if (
      typeof sliderInfo.defersTo !== "undefined" &&
      Slider.activeSliders.indexOf(sliderInfo.defersTo) >= 0
    ) {
      // Don't show this slider if it is deferring to an active slider
      return;
    }
    Slider.activeSliders.push(id);

    if (
      typeof sliderInfo.daysDismissLasts !== "undefined" &&
      !sliderInfo.daysDismissLasts &&
      !sliderInfo.hoursDismissLasts
    ) {
      console.log(
        "INTERNAL ALERT: Slider " + id + " needs at least one dismiss time set."
      );
    }
    switch (sliderInfo.type) {
      case "countdown":
        if ($("." + id).length) {
          Slider.ShowCountDown(id, sliderInfo);
        }
        break;
      case "takeover":
        Slider.Takeover.Init(id, sliderInfo);
        break;
    }
    // Setting this allows email callout to be called
    Slider.sliderActivated = true;
  },
  loadAnimGifSS: function (id, sliderInfo) {
    const left_arrow =
        '<svg viewBox="0 0 10 16"><title>previous photo</title><path d="M7.429,0.428c0.571-0.571,1.429-0.571,2,0C10,1,10,1.857,9.429,2.429L3.214,8.571l6.357,6c0.571,0.571,0.571,1.429,0,2c-0.572,0.571-1.429,0.571-2,0L0.714,10C0.714,10,0,9.242,0,8.571s0.714-1.429,0.714-1.429L7.429,0.428z"/></svg>',
      right_arrow =
        '<svg viewBox="0 0 10 16"><title>next photo</title><path d="M2.571,0.428c-0.571-0.571-1.429-0.571-2,0C0,1,0,1.857,0.571,2.429l6.214,6.143l-6.357,6c-0.571,0.571-0.571,1.429,0,2c0.572,0.571,1.429,0.571,2,0L9.286,10C9.286,10,10,9.242,10,8.571S9.286,7.143,9.286,7.143L2.571,0.428z"/></svg>';

    let nav_bool = false,
      animate,
      speed;
    $("#" + id)
      .find(".animgif-slideshow")
      .each(function (index) {
        speed = $(this).hasClass("faster") ? 1500 : 2000;
        // console.log($(this));
        if ($(this).hasClass("flip")) {
          animate = {
            animateIn: "",
            animateOut: "",
          };
        } else {
          animate = {
            animateIn: "fadeIn",
            animateOut: "fadeOut",
          };
        }
        $(this).owlCarousel({
          items: 1,
          loop: true,
          nav: nav_bool,
          dots: nav_bool,
          navText: [left_arrow, right_arrow],
          lazyLoad: true,
          autoplay: true,
          autoplaySpeed: speed,
          autoplayTimeout: speed,
          autoplayHoverPause: false,
          mouseDrag: false,
          pullDrag: false,
          touchDrag: false,
          smartSpeed: speed,
          animateIn: animate.animateIn,
          animateOut: animate.animateOut,
        });

        $(this).unbind("focusin");
        $(this).blur();
      });
  },
  ShowCountDown: function (id, sliderInfo) {
    var inactiveTime = moment(new Date(sliderInfo.inactiveOn));
    var interval = 1000;
    var n, e, timeleft;
    var countdownHTML = "";
    countdownHTML +=
      "<span class='countdown-days countdown-num'><span class='num'></span> <span class='descriptor'>Days</span></span>";
    countdownHTML +=
      "<span class='countdown-hrs countdown-num'><span class='num'></span> <span class='descriptor'>Hrs</span></span>";
    countdownHTML +=
      "<span class='countdown-mins countdown-num'><span class='num'></span> <span class='descriptor'>Min</span></span>";
    countdownHTML +=
      "<span class='countdown-secs countdown-num'><span class='num'></span> <span class='descriptor'>Sec</span></span>";
    // countdownHTML += " <span class='countdown-num offer-date'><span class='date'>Offer Ends <br>" + inactiveTime.format('MMMM DD') + "</span></span> "/*<span class='countdown-num offer-date'>Until <br class='mbl-only'>Christmas</span></span>"*/;
    $(".countdown").prepend(countdownHTML);
    function count_down() {
      n = moment().unix();
      e = inactiveTime.unix();
      timeleft = moment.duration(e - n, "seconds");
      var daysLeft = timeleft.days();
      if (timeleft.days() >= 0) {
        $(".countdown-days .num").text(("0" + daysLeft).slice(-2));
      } else {
        $(".countdown-days .num").text("00");
      }
      if (timeleft.hours() >= 0) {
        $(".countdown-hrs .num").text(("0" + timeleft.hours()).slice(-2));
      } else {
        $(".countdown-hrs .num").text("00");
      }
      if (timeleft.minutes() >= 0) {
        $(".countdown-mins .num").text(("0" + timeleft.minutes()).slice(-2));
      } else {
        $(".countdown-mins .num").text("00");
      }
      if (timeleft.seconds() >= 0) {
        $(".countdown-secs .num").text(("0" + timeleft.seconds()).slice(-2));
      } else {
        $(".countdown-secs .num").text("00");
      }

      //            }
    }
    count_down();
    setInterval(function () {
      count_down();
    }, interval);
  },
  Takeover: {
    Init: function (id, sliderInfo) {
      $("#takeover").load(
        "/assets/ajax/takeovers.php",
        function (responseTxt, statusTxt, xhr) {

          if (statusTxt == "success") {
            var $slider = $("#" + id);
            $slider
              .find(".promo-click, .promo-close, .promo-close-txt")
              .attr("data-label", id);

            $(".promo-close, .promo-close-txt, .click-overlay").on(
              "click",
              function () {
                Slider.Takeover.Close(id);
                return false;
              }
            );

            $(".promo-click").on("click", function () {
              Slider.Takeover.SetDismiss(id);
            });

            setTimeout(function (e) {
              $("#takeover").addClass("loaded");
            }, 500);
            setTimeout(function () {
              $slider.fadeIn(500);
            }, 2500);
            if ($slider.find(".animgif-slideshow")) {
              setTimeout(function () {
                Slider.loadAnimGifSS(id, sliderInfo);
              }, 2500);
            }
            console.log(sliderInfo.countdown);
            if (sliderInfo.countdown) {
              Slider.ShowCountDown(id, sliderInfo);
            }

            // For GTM
            dataLayer.push({
              event: "Takeover Promo Display",
              takeover_promo_action: "display",
              custom_sale_promo_id: id,
            });
          }
          if (statusTxt == "error") {
            console.log("ERROR: loading sale popup");
          }
        }
      );
    },

    Close: function (id) {
      var $slider = $("#" + id);
      $slider.fadeOut(300, function () {
        $(this).remove();
      });
      this.SetDismiss(id);
    },

    SetDismiss: function (id) {
      localStorage.setItem(id, "no");
      localStorage.setItem(
        id + "-time",
        moment().format("MM/DD/YYYY HH:mm:ss")
      );
    },
  },
};

function hasLocalStorage() {
    return isStorageAvailable('localStorage');
}

function isStorageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0;
    }
}